<template>
    <div class="row">
        <p v-if="error" class="text-danger">{{errorMsg}}</p>
        <div class="col-12">
            <base-attr-display-text
                v-for="field in dataForDisplay"
                :key="field.key"
                :label="field.label"
            >
                {{ field.value }}
            </base-attr-display-text>
        </div>
    </div>
</template>

<script>
import { suppliosApi } from '../js/api-service';
//import intersection from 'lodash/intersection';

export default {
    name: 'CompanyDetailSummary',
    props: {
        vendorPk: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error while getting Vendor information',
            error: false,
            loading: false,
            vendorData: {},
            fields: [
                {
                    key: 'name',
                    label: 'Name',
                },
                {
                    key: 'address',
                    label: 'Address',
                },
                {
                    key: 'website',
                    label: 'Website',
                },
            ],
        }
    },
    computed: {
        availableFields: function() {
            // go through keys for what we got from API and see what's available
            return Object.keys(this.vendorData);  // an array of keys available
        },
        dataForDisplay: function() {
            // takes list of fields, then fields from API, and outputs only those that are available
            // outputs array of objects with keys of key, label, value
            let fieldsForDisplay = this.fields.filter(field => {
                return this.availableFields.includes(field.key);
            });  // that only filtered our list of key/labels... still need to add value
            return fieldsForDisplay.map(f => {
                let displayObj = {...f};
                displayObj['value'] = this.vendorData[f.key];
                return displayObj;
            });
        },
    },
    mounted: function() {
        this.getData();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getData: function() {
            this.loading = true;
            suppliosApi.vendorStandard.retrieve(this.vendorPk)
            .then(response => {
                console.log(response);
                this.vendorData = Object.assign({}, response.data);
            })
            .catch(error => this.handleError(error, 'Error while getting vendor data'))
            .finally(() => {
                this.loading = false;
            })
        },
    }

}
</script>

<style>

</style>